/* @flow */
import React from 'react';

import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';
import Td from 'components/UIKit/Table/Td';

type TransactionsColumnsProps = {
  sort: string,
  order: string
}

export default function TransactionsColumns({
  sort, order
}: TransactionsColumnsProps): React.Element {
  return (
    <THead>
      <Tr>
        <Th sort={sort} order={order} style={{paddingLeft: '2.8rem'}} sortable field="id">ID</Th>
        <Th>Type</Th>
        <Th>Step</Th>
        <Th sort={sort} order={order} sortable field="created_datetime">DateTime</Th>
        <Th>User</Th>
        <Th>State</Th>
        <Td />
      </Tr>
    </THead>
  );
}
